import * as congNoConstant from './constants'

export const congNoNvkdListRequest = (payload, callback) => {
  return {
    type: congNoConstant.CONGNO_KH_NVKD_LIST_REQUESTING,
    payload,
    callback
  }
}

export const congNoNvkdListSuccess = (data) => {
  return {
    type: congNoConstant.CONGNO_KH_NVKD_LIST_SUCCESS,
  }
}

export const congNoNvkdListError = (error) => {
  return {
    type: congNoConstant.CONGNO_KH_NVKD_LIST_ERROR,
    error
  }
}
export const congNoDsKhListRequest = (payload, callback) => {
  return {
    type: congNoConstant.CONGNO_KH_KH_LIST_REQUESTING,
    payload,
    callback
  }
}

export const congNoDsKhListSuccess = () => {
  return {
    type: congNoConstant.CONGNO_KH_KH_LIST_SUCCESS
  }
}

export const congNoDsKhListError = (error) => {
  return {
    type: congNoConstant.CONGNO_KH_KH_LIST_ERROR,
    error
  }
}

export const congNoListRequest = (payload, callback) => {
  return {
    type: congNoConstant.CONGNO_KH_LIST_REQUESTING,
    payload,
    callback
  }
}

export const congNoListSuccess = (data) => {
  return {
    type: congNoConstant.CONGNO_KH_LIST_SUCCESS,
  }
}

export const congNoListError = (error) => {
  return {
    type: congNoConstant.CONGNO_KH_LIST_ERROR,
    error
  }
}

export const congNoCtListRequest = (payload, callback) => {
  return {
    type: congNoConstant.CONGNOCT_KH_LIST_REQUESTING,
    payload,
    callback
  }
}

export const congNoCtListSuccess = (data) => {
  return {
    type: congNoConstant.CONGNOCT_KH_LIST_SUCCESS,
  }
}

export const congNoCtListError = (error) => {
  return {
    type: congNoConstant.CONGNOCT_KH_LIST_ERROR,
    error
  }
}

export const reportExportXlsRequest = (payload, callback) => {
  return {
    type: congNoConstant.CONGNO_KH_EXPORT_XLS_REQUESTING,
    payload,
    callback
  }
}

export const reportExportXlsSuccess = (data) => {
  return {
    type: congNoConstant.CONGNO_KH_EXPORT_XLS_SUCCESS,
  }
}

export const reportExportXlsError = (error) => {
  return {
    type: congNoConstant.CONGNO_KH_EXPORT_XLS_ERROR,
    error
  }
}

export const congNoDvhcListRequest = (payload, callback) => {
  return {
    type: congNoConstant.CONGNO_KH_DVHC_LIST_REQUESTING,
    payload,
    callback
  }
}

export const congNoDvhcListSuccess = (data) => {
  return {
    type: congNoConstant.CONGNO_KH_DVHC_LIST_SUCCESS,
  }
}

export const congNoDvhcListError = (error) => {
  return {
    type: congNoConstant.CONGNO_KH_DVHC_LIST_ERROR,
    error
  }
}

export const congNoNvUpdateRequest = (payload, callback) => {
  return {
    type: congNoConstant.CONGNO_KH_UPDATE_REQUESTING,
    payload,
    callback
  }
}

export const congNoNvUpdateSuccess = () => {
  return {
    type: congNoConstant.CONGNO_KH_UPDATE_SUCCESS,
  }
}

export const congNoNvUpdateError = (error) => {
  return {
    type: congNoConstant.CONGNO_KH_UPDATE_ERROR,
    error
  }
}


export const congNoNhanVienByKhListRequest = (payload, callback) => {
  return {
    type: congNoConstant.CONGNO_NV_BY_KH_LIST_REQUESTING,
    payload,
    callback
  }
}

export const congNoNhanVienByKhListSuccess = (data) => {
  return {
    type: congNoConstant.CONGNO_NV_BY_KH_LIST_SUCCESS,
  }
}

export const congNoNhanVienByKhListError = (error) => {
  return {
    type: congNoConstant.CONGNO_NV_BY_KH_LIST_ERROR,
    error
  }
}

export const congNoNvExportXlsRequest = (payload, callback) => {
  return {
    type: congNoConstant.CONGNO_NV_BY_KH_EXPORT_XLS_REQUESTING,
    payload,
    callback
  }
}

export const congNoNvExportXlsSuccess = (data) => {
  return {
    type: congNoConstant.CONGNO_NV_BY_KH_EXPORT_XLS_SUCCESS,
  }
}

export const congNoNvExportXlsError = (error) => {
  return {
    type: congNoConstant.CONGNO_NV_BY_KH_EXPORT_XLS_ERROR,
    error
  }
}
export const congNoNvUploadRequest = (formData, callback) => {
  return {
    type: congNoConstant.CONGNO_NV_BY_KH_UPLOAD_REQUESTING,
    payload: formData,
    callback
  }
}

export const congNoNvUploadSuccess = (response) => {
  return {
    type: congNoConstant.CONGNO_NV_BY_KH_UPLOAD_SUCCESS,
    payload: response
  }
}

export const congNoNvUploadError = (error) => {
  return {
    type: congNoConstant.CONGNO_NV_BY_KH_UPLOAD_ERROR,
    error
  }
}


// WEBPACK FOOTER //
// ./src/views/CongNoKhachHang/actions.js